import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { MatButtonModule } from '@angular/material/button';
import { Subscription } from 'rxjs';
import packageJson from '../../../../package.json';
import { environment } from '../../../environments/environment';
import { MenuItem } from './models/MenuItem';
import { MenuItems } from './models/MenuItems';
import { SCREENING_REPORT_LINK, canViewScreeningReport } from '../../feature/screening-report/screening-report-access';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    RouterLink,
    MatListModule,
    MatButtonModule
  ]
})
export class SidebarComponent implements OnInit, OnDestroy {

  @Input() isExpanded: boolean | undefined;
  @Output() toggleMenu = new EventEmitter();

  @ViewChild('mainBody') mainBody: ElementRef | undefined;

  navSubscription: Subscription | undefined;
  appVersion: string = packageJson.version;
  showVersion: boolean = false;

  constructor(public router: Router, private msal: MsalService) { }

  get menuItems(): MenuItem[] {
    return MenuItems.filter(item => item.link !== SCREENING_REPORT_LINK || canViewScreeningReport(this.msal));
  }

  ngOnInit(): void {
    this.showVersion = !environment.production;
  }

  ngOnDestroy(): void {
    if (this.navSubscription) {
      this.navSubscription.unsubscribe();
    }
  }
}
